<template lang="pug">
div
  .app-error(v-if="error") App source is not available...
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'AppContainer',
  data() {
    return {
      error: false
    }
  },
  computed: {
    ...mapGetters({
      app: 'app/data'
    })
  },
  created() {
    window.BtApp = this.app

    this.connectToApp()
  },
  methods: {
    connectToApp() {
      let appUrl

      switch (this.app.appType) {
        case 'TOURIST_TOUCH':
          appUrl = `${process.env.BASE_URL}apps/tourist-touch`
          break
        case 'DIGITAL_SIGNAGE':
          appUrl = `${process.env.VUE_APP_CMS_URL}ds-generic`
          break
        case 'KEY_CABINET':
          appUrl = `${process.env.BASE_URL}apps/key-cabinet`
          break
        case 'PAY_BOX':
          appUrl = `${process.env.BASE_URL}apps/paybox`
          break
        default:
          appUrl = `${process.env.BASE_URL}apps/tourist-touch`
      }

      const url = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_URL : appUrl

      console.log(`[BergOS][APP] ID: ${this.app.id} | URL: ${url}`)

      axios
        .get(url)
        .then(response => {
          document.open()
          document.write(response.data)
          document.close()
          console.log(`[BergOS][APP] connectToApp - Success!`)
        })
        .catch(err => {
          this.error = true
          console.error(`[BergOS][APP] connectToApp - Error: ${JSON.stringify(err)}`)
          setTimeout(() => {
            this.connectToApp()
          }, 5000)
        })
    }
  }
}
</script>

<style lang="scss">
.app-error {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $color-muted;
}
</style>
